import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    throw new Error('Socket not initialized. Call initSocket() first.');
  }
  return socket;
}

export function initSocket(token?: string, sessionToken?: string): Socket {
  if (socket?.connected) return socket;

  const WS_URL = process.env.NEXT_PUBLIC_WS_URL || 'http://localhost:4000';

  socket = io(WS_URL, {
    transports: ['websocket', 'polling'],
    withCredentials: true, // sends the httpOnly JWT cookie on the handshake request
    auth: {
      ...(token && { token }),
      ...(sessionToken && { sessionToken }),
    },
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  socket.on('connect', () => {
    console.log('Socket connected:', socket?.id);
  });

  socket.on('connect_error', (err) => {
    console.error('Socket connection error:', err.message);
  });

  socket.on('disconnect', (reason) => {
    console.warn('Socket disconnected:', reason);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function isSocketConnected(): boolean {
  return socket?.connected ?? false;
}
